import { cn } from 'lib/cn';
import env from 'config/env';

const LINKS = [
  { key: 'vendorTerms', label: 'Vendor Terms' },
  { key: 'termsOfService', label: 'Terms of Service' },
  { key: 'privacyPolicy', label: 'Privacy Policy' },
  { key: 'cancellationPolicy', label: 'Cancellation Policy' },
];

/**
 * Renders the configured legal/policy links (from env). Anything without a URL
 * configured is simply omitted, so it degrades gracefully.
 */
export function LegalLinks({ className }) {
  const links = LINKS.map((link) => ({ ...link, href: env.legal[link.key] })).filter(
    (link) => link.href,
  );

  if (links.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap items-center justify-center gap-x-3 gap-y-1', className)}>
      {links.map((link) => (
        <a
          key={link.key}
          href={link.href}
          target="_blank"
          rel="noreferrer"
          className="text-xs text-slate-400 underline-offset-2 transition hover:text-slate-600 hover:underline"
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}

export default LegalLinks;
